<template>
  <div>
    <PageHeader
      title="Messagerie > Paramètres"
      :description="`Configuration du canal ${cseLabel}, des délais de réponse et des messages automatiques.`"
    />
    <ChatsSubmenu />

    <PageContent>
      <MessagingSettingsPanel :show-global-templates="false" />
    </PageContent>
  </div>
</template>

<script>
import PageHeader from '@/components/PageHeader.vue'
import PageContent from '@/components/PageContent.vue'
import MessagingSettingsPanel from '@/components/chats/MessagingSettingsPanel.vue'
import ChatsSubmenu from './ChatsSubmenu.vue'
import { resolveContactDenomination } from '@/utils/contactDenomination'

export default {
  name: 'ChatsSettingsPage',
  components: {
    PageHeader,
    PageContent,
    MessagingSettingsPanel,
    ChatsSubmenu
  },
  computed: {
    cseLabel () {
      return resolveContactDenomination(this.$store.getters.domain, this.$store.getters.application)
    },
    isAdmin () {
      return this.$store.getters.roles.includes('admin')
    }
  },
  created () {
    if (!this.isAdmin) {
      this.$router.replace('/app/chats')
    }
  }
}
</script>
